/* Kinderherz Galerie – global.js */
(function () {
  'use strict';
  var S = window.KH_SETTINGS || {};
  function fmtMoney(cents) {
    var f = S.moneyFormat || '{{amount_with_comma_separator}} \u20AC';
    var amount = (cents / 100).toFixed(2);
    var de = amount.replace('.', ',');
    return f
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, de)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount\s*\}\}/, amount);
  }
  function qs(sel, root) { return (root || document).querySelector(sel); }
  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  /* ---------- Drawers / Overlays ---------- */
  var overlay = qs('[data-drawer-overlay]');
  var openEl = null;
  function openDrawer(el) {
    if (!el) return;
    closeDrawer();
    el.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.style.overflow = 'hidden';
    openEl = el;
    var f = el.querySelector('input,button,a');
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  function closeDrawer() {
    if (openEl) openEl.hidden = true;
    qsa('[data-cart-drawer],[data-nav-drawer],[data-search-overlay]').forEach(function (el) { el.hidden = true; });
    if (overlay) overlay.hidden = true;
    document.body.style.overflow = '';
    openEl = null;
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart],[data-open-nav],[data-open-search],[data-drawer-close]');
    if (!t) return;
    e.preventDefault();
    if (t.hasAttribute('data-drawer-close')) return closeDrawer();
    if (t.hasAttribute('data-open-cart')) { renderCart(); openDrawer(qs('[data-cart-drawer]')); }
    if (t.hasAttribute('data-open-nav')) openDrawer(qs('[data-nav-drawer]'));
    if (t.hasAttribute('data-open-search')) openDrawer(qs('[data-search-overlay]'));
  });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Header scroll state ---------- */
  var header = qs('.site-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 4); };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- Cart (AJAX) ---------- */
  function updateCounts(cart) {
    qsa('[data-cart-count],[data-cart-count-drawer]').forEach(function (el) { el.textContent = cart.item_count; });
    qsa('[data-cart-count-bubble]').forEach(function (el) { el.hidden = cart.item_count === 0; });
  }
  function cartMsg(text) {
    var box = qs('[data-cart-msg]');
    if (!box) return;
    box.textContent = text;
    box.hidden = !text;
    if (text) setTimeout(function () { box.hidden = true; }, 4500);
  }
  function renderCart() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      updateCounts(cart);
      var wrap = qs('[data-cart-lines]');
      var empty = qs('[data-cart-empty]');
      var foot = qs('[data-cart-foot]');
      if (!wrap) return;
      if (empty) empty.hidden = cart.item_count > 0;
      if (foot) foot.hidden = cart.item_count === 0;
      var sub = qs('[data-cart-subtotal]');
      if (sub) sub.textContent = fmtMoney(cart.total_price);
      var imp = qs('[data-cart-impact]');
      if (imp) imp.textContent = fmtMoney(Math.round(cart.total_price * (S.spendeAnteil || 10) / 100));
      wrap.innerHTML = cart.items.map(function (it) {
        var opts = it.product_has_only_default_variant ? '' : it.variant_title || '';
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, '_200x$1$2') : '';
        return '<div class="cart-line" data-line-key="' + it.key + '">' +
          '<a class="cart-line__media" href="' + it.url + '">' + (img ? '<img src="' + img + '" alt="">' : '') + '</a>' +
          '<div class="cart-line__body">' +
            '<div class="cart-line__top"><a class="cart-line__title" href="' + it.url + '">' + it.product_title + '</a>' +
            '<span class="cart-line__price">' + fmtMoney(it.final_line_price) + '</span></div>' +
            (opts ? '<div class="cart-line__meta">' + opts + '</div>' : '') +
            '<div class="cart-line__controls">' +
              '<div class="qty-stepper"><button type="button" data-qty-change="-1" aria-label="Menge verringern">\u2212</button>' +
              '<span>' + it.quantity + '</span>' +
              '<button type="button" data-qty-change="1" aria-label="Menge erh\u00f6hen">+</button></div>' +
              '<button type="button" class="cart-line__remove" data-line-remove>Entfernen</button>' +
            '</div>' +
          '</div></div>';
      }).join('');
    });
  }
  document.addEventListener('click', function (e) {
    var chg = e.target.closest('[data-qty-change]');
    var rm = e.target.closest('[data-line-remove]');
    if (!chg && !rm) return;
    var line = e.target.closest('[data-line-key]');
    if (!line) return;
    var key = line.getAttribute('data-line-key');
    var current = parseInt(line.querySelector('.qty-stepper span').textContent, 10) || 1;
    var qty = rm ? 0 : Math.max(0, current + parseInt(chg.getAttribute('data-qty-change'), 10));
    fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function (r) { return r.json(); }).then(function (res) {
      if (res.status && res.status !== 200) { cartMsg(res.description || res.message || S.cartUnikatMsg); }
      renderCart();
      if (qs('[data-cart-page]')) location.reload();
    });
  });
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]');
    if (btn) { btn.disabled = true; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (!res.ok) {
          var msg = res.j.description || res.j.message || 'Das hat leider nicht geklappt.';
          var box = form.querySelector('[data-form-error]');
          if (box) { box.textContent = msg; box.hidden = false; } else { cartMsg(msg); openDrawer(qs('[data-cart-drawer]')); renderCart(); }
          return;
        }
        renderCart();
        openDrawer(qs('[data-cart-drawer]'));
      });
  });
  fetch('/cart.js').then(function (r) { return r.json(); }).then(updateCounts).catch(function () {});

  /* ---------- Predictive search ---------- */
  var searchInput = qs('[data-search-input]');
  if (searchInput) {
    var resultsWrap = qs('[data-search-results]');
    var label = qs('[data-search-label]');
    var timer;
    searchInput.addEventListener('input', function () {
      clearTimeout(timer);
      var q = searchInput.value.trim();
      timer = setTimeout(function () {
        if (!q) { if (label) label.textContent = 'Beliebte Kunstwerke'; return; }
        fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4')
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var items = (data.resources && data.resources.results.products) || [];
            if (label) label.textContent = items.length ? 'Vorschl\u00e4ge' : 'Keine Kunstwerke gefunden \u2013 probiere einen anderen Begriff.';
            if (!resultsWrap) return;
            resultsWrap.innerHTML = items.map(function (p) {
              return '<a class="search-tile" href="' + p.url + '">' +
                '<span class="search-tile__img">' + (p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=200" alt="">' : '') + '</span>' +
                '<span class="search-tile__title">' + p.title + '</span>' +
                '<span class="search-tile__price">' + p.price + '</span></a>';
            }).join('');
          });
      }, 220);
    });
  }

  /* ---------- Wishlist (localStorage) ---------- */
  var WKEY = 'kh-wish';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wishPaint() {
    var w = wishGet();
    qsa('[data-wish]').forEach(function (b) {
      b.classList.toggle('is-active', w.indexOf(b.getAttribute('data-wish')) > -1);
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var h = b.getAttribute('data-wish');
    var w = wishGet();
    var i = w.indexOf(h);
    if (i > -1) w.splice(i, 1); else w.push(h);
    try { localStorage.setItem(WKEY, JSON.stringify(w)); } catch (err) {}
    wishPaint();
  });
  wishPaint();

  /* ---------- Produkt: Varianten ---------- */
  var pform = qs('[data-product-form]');
  if (pform) {
    var variants = JSON.parse(qs('[data-variants-json]').textContent);
    var idInput = pform.querySelector('input[name=id]');
    function selectedOptions() {
      return qsa('fieldset', pform).map(function (fs) {
        var c = fs.querySelector('input:checked');
        return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }
    function paint() {
      var opts = selectedOptions();
      var v = findVariant(opts);
      var priceEl = qs('[data-pdp-price]');
      var compareEl = qs('[data-pdp-compare]');
      var buyBtn = qs('[data-pdp-add]');
      qsa('fieldset', pform).forEach(function (fs, fi) {
        qsa('.option-pill', fs).forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[fi] = val;
          var cand = findVariant(test);
          pill.classList.toggle('is-unavailable', !cand || !cand.available);
        });
      });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = fmtMoney(v.price);
      if (compareEl) {
        compareEl.hidden = !(v.compare_at_price && v.compare_at_price > v.price);
        if (!compareEl.hidden) compareEl.textContent = fmtMoney(v.compare_at_price);
      }
      if (buyBtn) {
        buyBtn.disabled = !v.available;
        buyBtn.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      var sp = qs('[data-sticky-price]');
      if (sp) sp.textContent = fmtMoney(v.price);
      if (v.featured_media && v.featured_media.id) switchMedia(v.featured_media.id);
    }
    pform.addEventListener('change', function (e) { if (e.target.matches('input[type=radio]')) paint(); });
    paint();
  }

  /* ---------- Produkt: Galerie ---------- */
  function switchMedia(id) {
    qsa('[data-media-item]').forEach(function (m) { m.hidden = m.getAttribute('data-media-item') !== String(id); });
    qsa('[data-media-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', t.getAttribute('data-media-thumb') === String(id) ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-media-thumb]');
    if (t) switchMedia(t.getAttribute('data-media-thumb'));
  });

  /* ---------- Produkt: Menge + Sticky-Buy ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-btn]');
    if (!b) return;
    var input = qs('input[name=quantity]');
    var span = qs('[data-qty-display]');
    if (!input) return;
    var v = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty-btn'), 10));
    input.value = v;
    if (span) span.textContent = v;
  });
  var buyAnchor = qs('[data-buy-anchor]');
  var sticky = qs('[data-sticky-buy]');
  if (buyAnchor && sticky && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      sticky.classList.toggle('is-visible', !en[0].isIntersecting);
    }).observe(buyAnchor);
  }

  /* ---------- Collection: Filter auto-submit ---------- */
  var filterForm = qs('[data-filter-form]');
  if (filterForm) {
    filterForm.addEventListener('change', function () { filterForm.submit(); });
  }
  var sortSelect = qs('[data-sort-select]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      location.href = url.toString();
    });
  }

  /* ---------- Cookie banner ---------- */
  var cb = qs('[data-cookie-banner]');
  if (cb) {
    var stored = null;
    try { stored = localStorage.getItem('kh-cookie'); } catch (e) {}
    if (!stored) cb.hidden = false;
    cb.addEventListener('click', function (e) {
      var acc = e.target.closest('[data-cookie-accept]');
      var tog = e.target.closest('[data-cookie-toggle]');
      if (tog) { var st = qs('[data-cookie-settings]'); st.hidden = !st.hidden; return; }
      if (!acc) return;
      var mode = acc.getAttribute('data-cookie-accept');
      var stats = qs('[data-cookie-stats]');
      if (mode === 'notwendige' && stats && stats.checked) mode = 'notwendige+statistik';
      try { localStorage.setItem('kh-cookie', mode); } catch (e2) {}
      cb.hidden = true;
    });
  }
})();
